import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { SharedFile } from '../SharedFiles.types';
import { SharedFilesSharedMoveForm } from './SharedFilesSharedMoveForm';

type SharedFilesItemMoveForm = {
  closeModal: () => void;
  file: SharedFile;
};

/**
 * Form to move a single shared file to any other ShareFile directory.
 */
export function SharedFilesItemMoveForm({ closeModal, file }: SharedFilesItemMoveForm) {
  const { t } = useSonTranslation('SharedFiles');

  return (
    <ModalDialog
      closeModal={closeModal}
      headline={t('forms.move.modalHeadline', { name: file.fileTitle || file.fileName })}
      initialFocusIndex={2}
    >
      <SharedFilesSharedMoveForm
        form={file!.forms!.move!}
        selectedFiles={[file.id]}
        submitButtonLabel={t('forms.move.submitButton')}
        messageSuccess={t('forms.move.success')}
        messageSending={t('forms.move.sending')}
        messageFail={t('forms.move.fail')}
        messageSuccessTranslationKey="SharedFiles:forms.move.success"
      />
    </ModalDialog>
  );
}
